import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { ClubAssociationOnboardingService } from "@/services/onboarding/ClubAssociationOnboardingService";
import type { ClubAssociationEditInput, ClubAssociationOnboardingInput } from "@/types/customer-onboarding";

export const useCreateClubAssociationGenie = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: ClubAssociationOnboardingInput) => ClubAssociationOnboardingService.createGenie(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agents"] });
      queryClient.invalidateQueries({ queryKey: ["agents-list"] });
      queryClient.invalidateQueries({ queryKey: ["user-agents"] });
      toast.success("Your genie setup has started.");
    },
    onError: (error: Error) => {
      toast.error(error.message || "We could not start the setup. Please sign in and try again.");
    },
  });
};

export const useUpdateClubAssociationOnboarding = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: ClubAssociationEditInput) => ClubAssociationOnboardingService.updateDetails(input),
    onSuccess: (_, input) => {
      queryClient.invalidateQueries({ queryKey: ["agent", input.agent.id] });
      queryClient.invalidateQueries({ queryKey: ["agents"] });
      queryClient.invalidateQueries({ queryKey: ["agents-list"] });
      queryClient.invalidateQueries({ queryKey: ["user-agents"] });
      toast.success("Details saved.");
    },
    onError: (error: Error) => {
      toast.error(error.message || "We could not save those details.");
    },
  });
};
